import { render, staticRenderFns } from "./ChoosePublish.vue?vue&type=template&id=6297f283&scoped=true&"
import script from "./ChoosePublish.vue?vue&type=script&lang=js&"
export * from "./ChoosePublish.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePublish.vue?vue&type=style&index=0&id=6297f283&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297f283",
  null
  
)

export default component.exports